(() => {
  if (window.__omCartLayoutControlV2Initialized) {
    return;
  }

  window.__omCartLayoutControlV2Initialized = true;

  const UPSELL_CONTAINER_SELECTOR =
    '[data-essential-upsell-element="container"]';

  const UPSELL_TITLE_SELECTOR =
    '[data-essential-upsell-element="title"]';

  const MOBILE_BREAKPOINT = 749;

  let arrangementTimer = null;
  let placeholder = null;
  let mobileWrapper = null;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function getDirectChildOfMain(element, main) {
    let current = element;

    while (
      current &&
      current.parentElement !== main
    ) {
      current = current.parentElement;
    }

    return (
      current &&
      current.parentElement === main
        ? current
        : null
    );
  }

  function getUpsellContainer() {
    return document.querySelector(
      UPSELL_CONTAINER_SELECTOR
    );
  }

  function renameUpsellHeading(container) {
    if (!container) {
      return;
    }

    const title = container.querySelector(
      UPSELL_TITLE_SELECTOR
    );

    if (title) {
      title.textContent =
        'Complete Kanha Ji’s Seva';
    }
  }

  function ensurePlaceholder(container) {
    if (
      placeholder &&
      placeholder.isConnected
    ) {
      return;
    }

    placeholder = document.createElement('span');
    placeholder.hidden = true;
    placeholder.setAttribute(
      'data-om-upsell-original-position',
      ''
    );

    container.parentElement.insertBefore(
      placeholder,
      container
    );
  }

  function ensureMobileWrapper(main, footerSection) {
    mobileWrapper = document.querySelector(
      '[data-om-mobile-upsell-wrapper]'
    );

    if (!mobileWrapper) {
      mobileWrapper = document.createElement('div');

      mobileWrapper.className =
        'om-cart-mobile-upsell';

      mobileWrapper.setAttribute(
        'data-om-mobile-upsell-wrapper',
        ''
      );
    }

    if (
      mobileWrapper.parentElement !== main ||
      footerSection.nextElementSibling !==
        mobileWrapper
    ) {
      footerSection.insertAdjacentElement(
        'afterend',
        mobileWrapper
      );
    }

    return mobileWrapper;
  }

  function moveUpsellForMobile(
    container,
    main,
    footerSection
  ) {
    ensurePlaceholder(container);

    const wrapper = ensureMobileWrapper(
      main,
      footerSection
    );

    if (container.parentElement !== wrapper) {
      wrapper.appendChild(container);
    }

    container.classList.add(
      'om-upsell-moved-mobile'
    );
  }

  function restoreUpsellForDesktop(container) {
    if (
      placeholder &&
      placeholder.isConnected &&
      container.parentElement !==
        placeholder.parentElement
    ) {
      placeholder.insertAdjacentElement(
        'afterend',
        container
      );
    }

    container.classList.remove(
      'om-upsell-moved-mobile'
    );

    if (
      mobileWrapper &&
      mobileWrapper.isConnected &&
      !mobileWrapper.children.length
    ) {
      mobileWrapper.remove();
    }
  }

  function updateEmptyCartState() {
  const cartItems = document.querySelector(
    'cart-items'
  );

  const hasCartProduct = Boolean(
    document.querySelector(
      'cart-items .cart-item'
    )
  );

  const isEmpty =
    !hasCartProduct ||
    Boolean(
      cartItems &&
      cartItems.classList.contains('is-empty')
    );

  document.body.classList.toggle(
    'om-cart-is-empty',
    isEmpty
  );

  return isEmpty;
}

function arrangeCart() {
  const main = document.querySelector(
    '#MainContent'
  );

  if (!main) {
    return;
  }

  const isEmpty = updateEmptyCartState();

  const cartFooter = document.querySelector(
    '#main-cart-footer'
  );

  if (isEmpty || !cartFooter) {
    return;
  }

  /*
    Move the custom note inside the same summary container
    as benefits, total and checkout. This avoids changing
    Dawn's Liquid structure.
  */
  const cartBlocks = cartFooter.querySelector(
    '.cart__blocks'
  );

  const cartNote = cartFooter.querySelector(
    '.om-cart-note'
  );

  if (
    cartBlocks &&
    cartNote &&
    cartNote.parentElement !== cartBlocks
  ) {
    cartBlocks.appendChild(cartNote);
  }

  const upsellContainer =
    getUpsellContainer();

  if (!upsellContainer) {
    return;
  }

  renameUpsellHeading(upsellContainer);

  const footerSection =
    getDirectChildOfMain(
      cartFooter,
      main
    );

  if (!footerSection) {
    return;
  }

  if (isMobile()) {
    moveUpsellForMobile(
      upsellContainer,
      main,
      footerSection
    );
  } else {
    restoreUpsellForDesktop(
      upsellContainer
    );
  }
}

  function scheduleArrangement(delay = 100) {
    window.clearTimeout(arrangementTimer);

    arrangementTimer = window.setTimeout(
      arrangeCart,
      delay
    );
  }

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      scheduleArrangement(50);
      scheduleArrangement(500);
      scheduleArrangement(1200);
    }
  );

  window.addEventListener(
    'load',
    () => scheduleArrangement(150)
  );

  window.addEventListener(
    'resize',
    () => scheduleArrangement(150)
  );

  document.addEventListener(
    'cart:updated',
    () => scheduleArrangement(250)
  );

  const observer = new MutationObserver(() => {
    scheduleArrangement(200);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();